import "@src/style.css";
import {createPinia} from "pinia";
import {createApp} from "vue";
import axios from "axios";
// @ts-ignore
import vClickOutside from "click-outside-vue3";
import App from "@src/App.vue";

import '@src/services/axios';
import '@src/services/db';
import {initStatusBar} from '@src/services/statusBar';
import toastPlugin from './plugins/toast';

const pinia = createPinia();
const app = createApp(App);


app.use(pinia);
app.use(toastPlugin);
app.use(vClickOutside);

app.mount("#app");

initStatusBar();
